// ----------------------------------------------------------------------

const account = {
  displayName: 'Daniel  Meynard A Mabunga',
  email: 'mabungadaniel@gmail.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
